import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_API = process.env.REACT_APP_BASE_API;
const KRANKQUE_SECRET_KEY = process.env.REACT_APP_KRANKQUE_SECRET_KEY;
const KRANKQUE_APPLICATION_ID = process.env.REACT_APP_KRANKQUE_APPLICATION_ID;



export const membersSlice = createApi({
  reducerPath: 'members',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState }) => {
      headers.set('Content-Type', 'application/json');

      if (KRANKQUE_SECRET_KEY) {
        headers.set('krankque-secret-key', KRANKQUE_SECRET_KEY);
      }

      if (KRANKQUE_APPLICATION_ID) {
        headers.set('krankque-application-id', KRANKQUE_APPLICATION_ID);
      }

      return headers;
    },
  }),
  tagTypes: ['Members'],
  endpoints: (builder) => ({

  }),
});

export const {

} = membersSlice;
